<div
  id="map-aside"
  *ngIf="hidden$ | async as hidden"
  [ngClass]="{ 'map-aside-disabled': !isCurrentlyHidden }"
  [ngClass]="{ 'map-aside-maximized': isMaximized$ | async }"
>
  <div
    class="content-map-aside"
    [className]="
      position === 'right' ? 'content-map-aside_pr' : 'content-map-aside_pl'
    "
    [ngClass]="{
      'content-map-aside-hidden_pr': !isCurrentlyHidden && position === 'right',
      'content-map-aside-hidden_pl': !isCurrentlyHidden && position === 'left'
    }"
  >
    <ng-container *ngIf="variant$ | async as variant">
      <div class="title-aside-container">
        <div class="title">
          <button class="button-icon" (click)="closeMapAside()">
            <!-- <svg width="20" height="20" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#arrowLeft"></use>
            </svg> -->
            <mat-icon size="20">west</mat-icon>
          </button>
          <ng-container [ngSwitch]="variant">
            <p *ngSwitchCase="'events'">Resumen del evento</p>
            <p *ngSwitchDefault>¡Variante no encontrada!</p>
          </ng-container>
        </div>
        <div class="tools d-flex flex-row justify-content-end gap-2 align-items-center">
          <button
            class="button-icon button-icon-close"
            (click)="closeMapAside()"
          >
            <mat-icon size="24">close</mat-icon>
          </button>
        </div>
        <div></div>
      </div>
      <ng-container [ngSwitch]="variant">
        <app-events-content *ngSwitchCase="'events'"></app-events-content>
        <!-- para añadir una variante se debe poner en el modelo y crear el componente y ponerlo aqui -->
        <p *ngSwitchCase="'history'">HISTORIAL</p>
        <app-not-found-content *ngSwitchDefault></app-not-found-content>
      </ng-container>
    </ng-container>
  </div>
</div>

